<div class="sidebar-container h-full flex flex-col">
  @if (viewMode() === 'SEARCH') {
    <div class="header">
      <h2>{{ 'Global.Search' | translate }}</h2>
      <button mat-icon-button (click)="closeSidebar()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="content custom-scrollbar flex-1 overflow-y-auto p-4">
      <app-searcher [displayResults]="false" (searchCompleted)="onSearchCompleted($event)" (aiStreamUpdate)="onAiStreamUpdate($event)"></app-searcher>

      @if (history().length > 0) {
        <div class="history-section">
          <p class="section-title">{{ 'Questions.AnalysisHistory' | translate }}</p>
          <div class="history-list custom-scrollbar">
            @for (item of formattedHistory(); track item._id) {
              <app-version-tile
                [version]="item"
                [isActive]="currentSearchId() === item._id"
                [showInsertAction]="false"
                [showChatAction]="true"
                (restore)="restoreSearch(item)"
                (chat)="openChat(item)"
                (delete)="deleteSearch($event, item)"
              ></app-version-tile>
            }
          </div>
        </div>
      }
    </div>
  } @else if (viewMode() === 'CHAT' && selectedSession()) {
    <div class="flex-1 overflow-hidden h-full">
      <app-search-chat [session]="selectedSession()" (back)="viewMode.set('SEARCH'); currentSearchId.set(null)" (close)="closeSidebar()" (sessionUpdated)="onSessionUpdated($event)"></app-search-chat>
    </div>
  }
</div>
